import "./Footer.css";

function Footer() {
  return (
    <div className="footer-container">2021-2022 © Rahat Maqsood Clinic</div>
  );
}

export default Footer;
